export default __webpack_public_path__ + "static/media/42.77b433f6.jpeg";